import TemplateView from './TemplateView'
import SimpleTooltip from './SimpleTooltip'
import $ from 'jquery'

export default class IconWithTooltip extends TemplateView {
    constructor(text) {
        super()
        this.text = text
    }

    templateHtml() {
        return "<div class='iconWithTooltip'></div>"
    }

    afterRender() {
        this.tooltip = new SimpleTooltip({
            text: this.text,
            extraClass: 'aboveMenuZindex createChartUserSelectorTooltip',
        }).init($('body'))
        this.tooltip.subscribeToMouseEvents(this.$el)
    }
}


// WEBPACK FOOTER //
// ./web/js/IconWithTooltip.js